type EMobilityTab = 'dashboard' | 'charging-history' | 'charging-sessions' | 'charging-cards' | 'wallbox' | 'tariffs'

export const getEMobilityTabRoute = (installationId: string | number = ':installationId', storageId?: string, tabName?: EMobilityTab): string => {
  const resolvedTabName = tabName ?? storageId

  if (tabName && storageId) {
    return `/e-mobility/${installationId}/${storageId}/${tabName}`
  }
  return `/e-mobility/${installationId}/${resolvedTabName || ':tabName'}`
}
